import { useEffect, useState } from "react";
import { AuditSession } from "../models/heretic/auditSession";
import { fetchFastApi } from "../utils/fastApi";

export const useAuditSessions = () => {
  const [auditSessions, setAuditSessions] = useState<AuditSession[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchAuditSessions = async () => {
    setLoading(true);
    try {
      const response = await fetchFastApi({
        method: "GET",
        path: "/matching/match-session/",
      });
      setAuditSessions(response.sessions);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAuditSessions();
  }, []);

  return { auditSessions, fetchAuditSessions, loading };
};
